export default __webpack_public_path__ + "static/media/actif.3caf31e0.svg";